import { CodespacesIcon, GitPullRequestClosedIcon, IdBadgeIcon, KeyAsteriskIcon, PeopleIcon } from "@primer/octicons-react";
import { Box, UnderlineNav } from "@primer/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sf_mucphaithu_insert_from_tbtp_rq } from "../../models/request/thu-phi/sf_mucphaithu_insert_from_tbtp_rq";
import { sf_mucphaithu_select_byhocsinh_rq } from "../../models/request/thu-phi/sf_mucphaithu_select_byhocsinh_rq";
import { hocSinhProfileActions } from "../../state/actions/hocSinhProfileActions";
import { RootState } from "../../state/reducers";
import HocSinhChungTu from "../hoc-sinh/hoc-sinh-chung-tu";
import TongHopLayout from "../hoc-sinh/thong-tin-quan-he/TongHopLayout";
import DangKyDichVuHocSinh from "../tbtp/edit_tbtp_modal/TbtpEditTab/DangKyDichVuHocSinh";
import HinhThucMienGiam from "../tbtp/edit_tbtp_modal/TbtpEditTab/HinhThucMienGiam";
import QuyetToanHocSinh from "../tbtp/edit_tbtp_modal/TbtpEditTab/QuyetToanHocSinh";
import { TBTPList } from "../thu-phi/tbtp";
type ThuPhiLayoutTabProps = {
    ts_hocsinh_id: number;
}
const ThuPhiLayout = (props: ThuPhiLayoutTabProps) => {
    const [selectedTab, setSelectedTab] = useState<"thuphi" | "quyettoan" | "miengiam" | "dichvu" | "quanhe">("thuphi");
    const {nam_hoc } = useSelector((state: RootState) => state.common);
    const { status } = useSelector((x: RootState) => x.hocSinhProfile);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(hocSinhProfileActions.changeFilter({
            nam_hoc: nam_hoc,
            ts_hocsinh_id: props.ts_hocsinh_id
        }))
    }, [props.ts_hocsinh_id, nam_hoc])

    useEffect(() => {
        if (nam_hoc && props.ts_hocsinh_id) {
            const datasend: sf_mucphaithu_select_byhocsinh_rq = { ts_hocsinh_id: props.ts_hocsinh_id, nam_hoc: nam_hoc }
            dispatch(hocSinhProfileActions.selectHocSinhStart(datasend))
            handleReloadSaleSet();
        }
    }, [nam_hoc, props.ts_hocsinh_id])

    const handleReloadSaleSet = () => {
        dispatch(hocSinhProfileActions.selectSaleSetStart({
            ts_hocsinh_id: props.ts_hocsinh_id,
            nam_hoc
        }))
    }

    const handleSubmitTBTP = async (rq: sf_mucphaithu_insert_from_tbtp_rq) => {
        try {
            await Promise.all([
                dispatch(hocSinhProfileActions.createThuPhiFromTBTPStart(rq)),
                dispatch(hocSinhProfileActions.selectSaleSetStart({
                    ts_hocsinh_id: props.ts_hocsinh_id,
                    nam_hoc
                }))
            ]);
        } catch (error) {
            console.error("Error reloading data: ", error);
        }
    }
    return (
        <Box>
            <UnderlineNav aria-label="tabs">
                <UnderlineNav.Item
                    icon={KeyAsteriskIcon}
                    aria-current={selectedTab === "thuphi" ? "page" : undefined}
                    onClick={() => setSelectedTab("thuphi")}
                >
                    THU PHÍ
                </UnderlineNav.Item>
                <UnderlineNav.Item
                    icon={CodespacesIcon}
                    aria-current={selectedTab === "dichvu" ? "page" : undefined}
                    onClick={() => setSelectedTab("dichvu")}
                >
                    DỊCH VỤ
                </UnderlineNav.Item>
                <UnderlineNav.Item
                    icon={GitPullRequestClosedIcon}
                    aria-current={selectedTab === "miengiam" ? "page" : undefined}
                    onClick={() => setSelectedTab("miengiam")}
                >
                    MIỄN GIẢM
                </UnderlineNav.Item>

                <UnderlineNav.Item
                    icon={IdBadgeIcon}
                    aria-current={selectedTab === "quyettoan" ? "page" : undefined}
                    onClick={() => setSelectedTab("quyettoan")}
                >
                    QUYẾT TOÁN
                </UnderlineNav.Item>
                <UnderlineNav.Item
                    icon={PeopleIcon}
                    aria-current={selectedTab === "quanhe" ? "page" : undefined}
                    onClick={() => setSelectedTab("quanhe")}
                >
                    QUAN HỆ
                </UnderlineNav.Item>
            </UnderlineNav>
            <Box>
                {selectedTab === "thuphi" &&
                    <Box>
                        <Box sx={{ mt:2 }}>
                            <TBTPList nam_hoc={nam_hoc}
                                ts_hocsinh_id={props.ts_hocsinh_id}
                                onSelected={handleSubmitTBTP}
                                status={status}
                            />
                            <HocSinhChungTu />
                            {/* <HocSinhCongNoGrid isShowEditBtn={true}
                                onReloadSaleSet={handleReloadSaleSet}
                            /> */}
                        </Box>
                    </Box>
                }
            </Box>
            <Box>
                {selectedTab === "quyettoan" &&
                    <QuyetToanHocSinh ts_hocsinh_id={props.ts_hocsinh_id} />
                }
            </Box>
            <Box>
                {selectedTab === "miengiam" &&
                    <HinhThucMienGiam ts_hocsinh_id={props.ts_hocsinh_id}
                    />
                }
            </Box>
            <Box>
                {selectedTab === "dichvu" &&
                    <DangKyDichVuHocSinh ts_hocsinh_id={props.ts_hocsinh_id}
                    />
                }
            </Box>
            <Box>
                {selectedTab === "quanhe" &&
                    <TongHopLayout ts_hocsinh_id={props.ts_hocsinh_id} />
                }
            </Box>
        </Box>
    );
};

export default ThuPhiLayout;